/*
 * @Descripttion: 社团活动类型 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-22
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-24 23:08:13
 */

import http from '@/utils/kq/http';

const veStuAssocActivityTypeApi = {
  //添加接口
  add(data) {
    return http.post(http.service.stu + 'veStuAssocActivityType/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.stu + 'veStuAssocActivityType/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.stu + 'veStuAssocActivityType/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.stu + 'veStuAssocActivityType/page', pageData);
  },
  //分页查询接口
  all(pageData) {
    return http.post(http.service.stu + 'veStuAssocActivityType/all', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.stu + 'veStuAssocActivityType/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.stu + 'veStuAssocActivityType/updateStatus', data);
  }
};
export default veStuAssocActivityTypeApi;
